import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=c8e9ab04&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8e9ab04')) {
      api.createRecord('c8e9ab04', component.options)
    } else {
      api.reload('c8e9ab04', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=c8e9ab04&", function () {
      api.rerender('c8e9ab04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z3p8DU16s86p/JS/comp/FavElement.vue"
export default component.exports